import { translate as t } from '@thoughtspot/i18n';
import { NEW_CHARTS_DEFAULT_FIELD_ID, TranslationKeys, } from './settings.constants';
const decodeBoolean = (raw) => {
    if (raw === undefined || raw === null || raw === '')
        return true;
    if (raw === 'true')
        return true;
    if (raw === 'false')
        return false;
    try {
        return atob(raw) === 'true';
    }
    catch {
        return false;
    }
};
export const decodeFeatureResponse = (data) => {
    const configs = data?.settings?.[0]?.configs ?? [];
    const get = (key) => configs.find((c) => c?.configName === key)?.value;
    return {
        newChartsDefault: decodeBoolean(get(NEW_CHARTS_DEFAULT_FIELD_ID)),
    };
};
export const encodeForPost = (values) => ({
    configOperation: 'add',
    configOptions: [
        {
            optionKey: NEW_CHARTS_DEFAULT_FIELD_ID,
            optionValue: btoa(String(values.newChartsDefault)),
            optionLabel: t(TranslationKeys.NEW_CHARTS_DEFAULT_LABEL),
        },
    ],
});
//# sourceMappingURL=settings.codec.js.map